import styled from 'styled-components';
import { transparentize } from 'polished';

export const RiskBarWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
`;

export const Bar = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 10px;
  margin-top: 15px;
  border: 1px solid ${(props) => props.theme.colors.black};
  border-radius: 10px;

  & > div {
    border-right: 1px solid ${(props) => transparentize(0.75, props.theme.colors.black)};
  }

  & > div:last-child {
    border-right: none;
    border-radius: 0 10px 10px 0;
  }

  & > div:first-child {
    border-radius: 10px 0 0 10px;
  }
`;

export const Segment = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  background-color: ${(p) =>
    ({
      selected: p.theme.colors.primary,
      below: p.theme.colors.primary90w,
      above: 'transparent',
    }[p.type])};
`;

export const InfoBox = styled.div`
  position: absolute;
  bottom: 9px;
  left: 0px;
  right: 0px;
  padding: 10px 15px;
  background-color: ${(p) => p.theme.colors.secondary98w};
`;

export const Marker = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: -6px;
  left: calc(${(props) => props.value}% - 2px);

  display: block;
  height: 20px;
  width: 2px;
  background-color: ${(props) => props.theme.colors.black};
  z-index: 5;
`;

export const ColoredMarker = styled.div`
  & :first-child {
    position: absolute;
    left: calc(${(props) => props.value}% - 50px);
    width: 100px;
    height: 10px;
    background-color: ${(props) => props.theme.colors.primary90w};
  }

  & :nth-child(2) {
    position: absolute;
    left: calc(${(props) => props.value}% - 25px);
    width: 50px;
    height: 10px;
    background-color: ${(props) => props.theme.colors.primary};
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 10px;

  & > * {
    display: flex;
    flex: 1;
    width: 100%;
    text-align: center;
  }
`;
